import { Share2 } from "lucide-react"
import { toast } from "sonner"
import type { Id } from "../../../../convex/_generated/dataModel"
import { cn } from "@/lib/utils"
import { usePendingAction } from "@/hooks/use-pending-action"
import { shareJob } from "../model/share-job"
import { capturePostHogEvent } from "@/lib/posthog"

export function ShareJobButton({
  jobId,
  title,
  companyName,
  variant = "labeled",
}: {
  jobId: Id<"jobs"> | string
  title: string
  companyName?: string
  variant?: "labeled" | "icon" | "outline"
}) {
  const { pending, run } = usePendingAction()
  const labeled = variant !== "icon"
  const label = variant === "outline" ? "Share role" : "Share"

  const onShare = () => {
    void run(
      async () => {
        const result = await shareJob({ jobId: String(jobId), title, companyName })
        capturePostHogEvent("job_shared", { share_result: result })
        if (result === "copied") toast.success("Link copied")
      },
      { error: "Couldn't share this role" },
    )
  }

  return (
    <button
      type="button"
      className={cn(
        variant === "outline"
          ? "home-wf-btn home-wf-btn--outline"
          : "mkt-row-action inline-flex items-center gap-1.5",
        variant === "icon" && "self-start",
        variant === "labeled" && "shrink-0",
      )}
      aria-label={`Share ${title}`}
      disabled={pending}
      onClick={onShare}
    >
      <Share2 className="size-4" aria-hidden />
      {labeled ? (pending ? "Sharing…" : label) : null}
    </button>
  )
}
